var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-checkbox',_vm._g({class:{ 'checkbox-info': _vm.variant === 'info' },attrs:{"autoFocus":_vm.autoFocus,"checked":_vm.checked,"defaultChecked":_vm.defaultChecked,"disabled":_vm.disabled,"indeterminate":_vm.indeterminate,"value":_vm.value},on:{"change":_vm.handleCheckboxChange}},_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }